export default __webpack_public_path__ + "static/media/image 116.adc47c5f.png";